import * as React from 'react';
import type { Maybe, TtdSettings } from '@types/gatsby-types';
import { graphql, useStaticQuery } from 'gatsby';

const query = graphql`
    query TtdSettingsQuery {
        settings {
            ttd {
                advertiserId
                initId
                startBookingEventId
                finishBookingEventId
                todaysAvailabilityEventId
                telehealthEventId
                emailSignupEventId
            }
        }
    }
`;

type TtdSettingsQuery = {
    settings: Maybe<{
        ttd: Maybe<TtdSettings>;
    }>;
};

type AugmentedTtdSettings = TtdSettings & {
    hasTtdPixel: boolean;
};

export default function useTtdSettings(): AugmentedTtdSettings {
    const { settings } = useStaticQuery<TtdSettingsQuery>(query);

    return React.useMemo(() => {
        if (settings?.ttd) {
            const { advertiserId, initId, ...rest } = settings.ttd;

            return {
                ...rest,
                advertiserId,
                initId,
                hasTtdPixel: !!advertiserId && !!initId,
            };
        }

        return {
            hasTtdPixel: false,
        };
    }, [settings?.ttd]);
}
